import { CalendarMode, CalendarView, Row } from "PFApp/booking/types";
import React, { forwardRef, JSX, RefObject } from "react";

import { RowType } from "../../../../../types/row";
import { WorkforceCalendarData } from "../../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../../context/bookings_overview_context";
import { BasicRow } from "../basic_row";
import { HeatMapRow } from "../heat_map_row";

type BookingsRowProps = {
  row: Row;
  startDate: string;
  endDate: string;
  draggedBookingId: number | null;
  shouldBarsOverlap: boolean;
  onLoadingChange: (value: boolean) => void;
  onBarDragStart: (value: number) => void;
  onBarDragEnd: () => void;
};

export const BookingsRow = forwardRef<HTMLDivElement, BookingsRowProps>(
  (
    {
      row,
      startDate,
      endDate,
      onLoadingChange,
      draggedBookingId,
      onBarDragStart,
      onBarDragEnd,
      shouldBarsOverlap
    },
    rowRef
  ): JSX.Element => {
    const { calendarMode, calendarData } = useBookingsOverviewContext();
    const { view } = calendarData;
    const isHeatMapEnabled =
      calendarMode === CalendarMode.Workforce
        ? (calendarData as WorkforceCalendarData).heatMapEnabled
        : false;
    const shouldDisplayHeatMapRow =
      calendarMode === CalendarMode.Workforce &&
      view === CalendarView.Compressed &&
      isHeatMapEnabled &&
      row.type === RowType.Profile;
    return (
      <>
        {shouldDisplayHeatMapRow ? (
          <HeatMapRow row={row} startDate={startDate} />
        ) : (
          <BasicRow
            mode={calendarMode}
            row={row}
            rowRef={rowRef as RefObject<HTMLDivElement>}
            startDate={startDate}
            endDate={endDate}
            onLoadingChange={onLoadingChange}
            draggedBookingId={draggedBookingId}
            onBarDragStart={onBarDragStart}
            onBarDragEnd={onBarDragEnd}
            shouldBarsOverlap={shouldBarsOverlap}
          />
        )}
      </>
    );
  }
);

BookingsRow.displayName = "BookingsRow";
